import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-login-email',
  templateUrl: './login-email.component.html',
  styleUrls: ['./login-email.component.scss'],
})
export class LoginEmailComponent implements OnInit {
  @Input() public loginWithEmail: boolean;
  @Output() public loginWithEmailChange = new EventEmitter();

  public loginForm: FormGroup;
  public busy: boolean;

  public reset() {
    this.loginWithEmailChange.emit(false);
  }

  constructor(
    fb: FormBuilder,
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {
    this.loginForm = fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }

  ngOnInit() {}

  public async login() {
    const { email, password } = this.loginForm.value;
    if (!email || !password) {
      return;
    }
    this.busy = true;
    try {
      await this.authService.loginWithEmailAndPassword(email, password);
      this.router.navigateByUrl('');
    } catch (e) {
      this.snackBar.open(e.message, null, { duration: 3000 });
    } finally {
      this.busy = false;
    }
  }
}
